import store from "@/store";
import { reactive, computed, onBeforeMount } from "@vue/composition-api";
import { dynamicBiModel } from "@/models/data-management/dynamic-bi";
import { dynamicBi } from "@/configs/dynamic-config/dynamic-bi";

export default function useBusinessIntelligence() {
  const { fetchDashBoardBI } = dynamicBiModel();

  const DynamicUI = reactive({
    BI: [],
    data: [],
  });

  const fetchDynamicBi = (from = "", to = "") => {
    DynamicUI.data = [];
    fetchDashBoardBI.payload.FromDate = from;
    fetchDashBoardBI.payload.ToDate = to;
    store.dispatch("api/apiRequest", fetchDashBoardBI).then((response) => {
      setTimeout(() => {
        DynamicUI.data = response.data.dynamicbidata;
      }, 300);
    });
  };

  onBeforeMount(() => {
    //mock
    DynamicUI.BI = dynamicBi.config;
    fetchDynamicBi();
  });
  return {
    DynamicUI,
    fetchDynamicBi,
  };
}
